<template>
    <div class="remaining-height overflow-auto" :style="style">
        <slot></slot>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    disable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      offsetTop: 0,
    };
  },
  computed: {
    style(): Object {
      return {
        height: this.disable ? 'auto' : `calc(100vh - ${this.offsetTop}px)`,
      };
    },
  },
  methods: {
    calculate(): void {
      if (!this.$el) return;
      this.offsetTop = this.$el.getBoundingClientRect().top;
    },
  },
  mounted(): void {
    this.calculate();
    window.addEventListener('resize', this.calculate);
  },
  beforeUnmount(): void {
    window.removeEventListener('resize', this.calculate);
  },
});
</script>
